$(document).ready(function(){
    $("#ae-year").html(new Date().getFullYear());
});


$(document).on('lazyloaded', function (e) {
    var $target = $(e.target);
    var $parent = $target.parent();
    if ($parent.hasClass("ae-img-spinner")) {
        $parent.addClass("ae-loaded");
    }
    if ($target.hasClass("ae-img-spinner")) {
        $target.addClass("ae-loaded");
    }
});

$(window).on("load", function () {
    $(".ae-img-spinner:not(.ae-loaded) .lazyloaded").each(function () {
        $(this).parent().addClass("ae-loaded");
        $(this).addClass("ae-loaded");
    });
});

/*** FORM  ***/
function FormLoad() {
  
    $("body").on("ae-lid-form.init-form", function (e, d) {

        $(".form-check").addClass("custom-control custom-checkbox");
        $(".form-check input").addClass("custom-control-input");
        $(".form-check label").addClass("custom-control-label");

        $("select").addClass("custom-select");

        $("button[type='submit']").after('<div class="spinner-border text-white d-none" role="status" id="waiting-form"></div>');

        setTimeout(function(){
          $("#landing-form").removeClass("ae-form-hidden");
        },300);
       

      });

      $("body").on("ae-lid-form.post-success", function (e, d) {
       
      });

      $("body").on("ae-lid-form.post-error", function (e, d) {
      
      });

      $(".ae-btn-scopri").on("click", function (e) {
        e.preventDefault();
        $(window).stop(true).scrollTo("#contact-us", {
            duration: 1500,
            offset: 0,
            easing: 'easeOutCirc'
        });
    });
}

